export interface IOrderInfoBody {
  available: boolean;
  currency: string;
  discount_shipping_price: number | null;
  discount_unit_price: number | null;
  free_subscription_months: number | null;
  installments: number;
  plant_count: number;
  shipping_price: number;
  starter_kit: string[];
  subscription_price: number;
  tax_included: boolean;
  tax_percentage: number;
  unit_price: number;
}

export interface ICoupon {
  id: string;
  description: string;
  discount_price?: number;
}

type TState = {
  isFetching: boolean;
  isLoaded: boolean;
  isFetched: boolean;
  orderInfo: IOrderInfoBody;
  coupon?: ICoupon;
};

type TAction = {
  type: string;
  payload: TState;
};

const initialState: TState = {
  isFetching: true,
  isLoaded: false,
  isFetched: false,
  orderInfo: {
    available: false,
    currency: '',
    installments: 0,
    plant_count: 0,
    subscription_price: 0,
    tax_percentage: 0,
    unit_price: 0,
    shipping_price: 0,
    starter_kit: [],
    discount_shipping_price: null,
    discount_unit_price: null,
    free_subscription_months: 0,
    tax_included: true
  },
};

export const orderInfoReducer = (
  state: TState = initialState,
  action: TAction
) => {
  switch (action.type) {
    case 'START_LOADING_ACTION':
      return { ...state, ...action.payload };

    case 'FINISHED_LOADING_ORDER_INFO_ACTION':
      return { ...state, ...action.payload };

    case 'FAILED_LOADING_ORDER_INFO_ACTION':
      return { ...state, ...action.payload };

    case 'ADD_COUPON':
      return { ...state, ...action.payload };

    case 'REMOVE_COUPON':
      return { ...state, coupon: undefined };

    default:
      return state;
  }
};

export const startFetchingOrderInfo = () => ({
  type: 'START_LOADING_ACTION',
  payload: {
    isFetching: true,
    isLoaded: false,
    orderInfo: { ...initialState.orderInfo },
  },
});

export const setOrderInfo = (payload: IOrderInfoBody) => ({
  type: 'FINISHED_LOADING_ORDER_INFO_ACTION',
  payload: {
    isFetching: false,
    isLoaded: true,
    orderInfo: payload,
    isFetched: true,
  },
});

export const failedFetchingOrderInfo = () => ({
  type: 'FAILED_LOADING_ORDER_INFO_ACTION',
  payload: {
    isFetching: false,
    isLoaded: false,
    orderInfo: { ...initialState.orderInfo },
  },
});

export const addCoupon = (payload: ICoupon,) => ({
  type: 'ADD_COUPON',
  payload: {
    coupon: payload,
  },
});

export const removeCoupon = () => ({
  type: 'REMOVE_COUPON',
});
